// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__3eZzK","gfeWrapper":"CalendarEvent_gfeWrapper__2nZZr"};